import addStartupScript from 'mex_components/app/scripts/events/addStartupScript';
import setupAddToCart from './add_to_cart';
import setupStraightEnrollment from './straight_enrollment';
import { condensedClassSummaries, classSummaries, detailsSetUp } from './buybox_utils';

export function toggleViewAllCards(allDetailCards) {
  Array.from(allDetailCards).forEach(function (card) {
    card.style.display = 'block';
  });
}

addStartupScript(() => {
  const allDetailCards = document.querySelectorAll('.course-detail-card');
  const fourthDetailCard = allDetailCards[3];
  const mediaQuery = window.matchMedia('(min-width: 460px)');
  setupAddToCart();
  setupStraightEnrollment();

  if (fourthDetailCard !== undefined && mediaQuery.matches) {
    const newViewAllLink = document.createElement('a');
    newViewAllLink.innerHTML = 'See All Class Offerings';
    newViewAllLink.setAttribute(
      'class',
      'button button--secondary js-view-all-cards'
    );
    fourthDetailCard.parentNode.insertBefore(newViewAllLink, fourthDetailCard);
  }

  const viewAllLink = document.querySelector('.js-view-all-cards');

  if (viewAllLink) {
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (target.classList.contains('js-view-all-cards')) {
        target.style.display = 'none';
        toggleViewAllCards(allDetailCards);
      }
    });
  }

  document.addEventListener('click', (event) => {
    detailsSetUp(event.target, mediaQuery, '.course-detail-card');
  });

  const condensedClassTimes = document.getElementsByClassName('class-times');
  const classTimes = document.getElementsByClassName('class-times-list');
  condensedClassSummaries(condensedClassTimes);
  classSummaries(classTimes);

  document.addEventListener('click', function(event) {
    const target = event.target.closest('a.buy-now-link');
    if (target) {
      event.preventDefault();
      const currentUrl = window.location.href;
      const loginUrl = `/login?return_to=${encodeURIComponent(currentUrl)}`;
      window.location.href = loginUrl;
    }
  });
});
